{
  "scenes": "Escenas",
  "search_scenes": "Buscar escenas",
  "no_results": "Sin resultados",
  "close": "Cerrar",
  "back": "Volver",
  "start": "Comenzar",
  "fullscreen": "Pantalla completa",
  "compact_controls": "Ocultar los controles",
  "expand_controls": "Mostrar los controles",
  "toggle_thumbnails": "Miniaturas de escena",
  "exit_fullscreen": "Salir de pantalla completa",
  "zoom_in": "Acercar",
  "zoom_out": "Alejar",
  "mute": "Silenciar",
  "unmute": "Activar sonido",
  "share": "Compartir",
  "copy_link": "Copiar enlace",
  "link_copied": "Enlace copiado",
  "vr_mode": "Modo VR",
  "gyro": "Giroscopio",
  "gaze_hint": "Mira un marcador y mantén la vista: el círculo se completa y se activa solo.",
  "help": "Ayuda",
  "language": "Idioma",
  "map": "Mapa",
  "floorplan": "Plano",
  "floorplan_enlarge": "Ampliar el plano",
  "floorplan_shrink": "Reducir el plano",
  "floorplan_close": "Cerrar el plano",
  "floorplan_show_spots": "Mostrar puntos",
  "floorplan_levels": "Plantas",
  "map_toggle_hint": "Mostrar u ocultar el plano (tecla M)",
  "compass": "Brújula",
  "loading": "Cargando",
  "menu": "Menú",
  "previous_scene": "Escena anterior",
  "help_title": "Cómo moverse",
  "help_drag": "Arrastra para mirar alrededor",
  "help_zoom": "Rueda del ratón o pellizco para hacer zoom",
  "help_keys": "Flechas del teclado para girar, +/- para zoom, Tab para recorrer los puntos de interés",
  "help_dblclick": "Doble clic para acercarte a un punto",
  "help_map_key": "Tecla M para mostrar u ocultar el plano",
  "download": "Descargar",
  "submit": "Enviar",
  "sending": "Enviando",
  "form_success": "Enviado correctamente. Gracias.",
  "form_error": "No se pudo enviar. Inténtalo de nuevo.",
  "required_field": "Este campo es obligatorio",
  "quiz_check": "Comprobar",
  "quiz_correct": "Correcto",
  "quiz_incorrect": "Incorrecto",
  "quiz_score": "Puntuación",
  "quiz_passed": "Aprobado",
  "quiz_failed": "No superado",
  "quiz_report": "Informe del cuestionario",
  "quiz_certificate": "Descargar certificado",
  "quiz_your_name": "Tu nombre para el certificado",
  "quiz_gate_message": "Responde correctamente para poder avanzar",
  "quiz_question_of": "Pregunta {n} de {total}",
  "quiz_prev": "Anterior",
  "quiz_next": "Siguiente",
  "quiz_see_result": "Ver el resultado",
  "quiz_review": "Repasar las preguntas",
  "quiz_summary_title": "Resultado",
  "quiz_summary": "Has acertado {correct} de {total}",
  "treasure_title": "Búsqueda del tesoro",
  "treasure_progress": "Encontrados {found} de {total}",
  "treasure_complete": "Búsqueda completada",
  "before": "Antes",
  "after": "Después",
  "open_external": "Se abre en una pestaña nueva",
  "accessible_mode": "Versión accesible",
  "made_with_andarama": "Hecho con Andarama",
  "accessible_intro": "Versión lineal accesible del tour con todas las escenas y contenidos.",
  "back_to_360": "Volver a la vista 360",
  "scene_of": "Escena {index} de {total}",
  "narration_wait": "Espera al final de la narración para continuar",
  "autoplay_tour": "Visita automática",
  "stop_autoplay": "Detener visita automática",
  "live_connected": "Conectado a la visita guiada",
  "live_follow": "Seguir al guía",
  "live_free": "Explorar libremente",
  "live_chat": "Chat",
  "live_send": "Enviar",
  "live_participants": "{count} participantes",
  "live_ended": "La visita guiada ha terminado",
  "welcome_controls": "Controles",
  "poweredby": "Creado con Andarama",
  "projection": "Proyección",
  "projection_rectilinear": "Normal",
  "projection_littlePlanet": "Little planet",
  "projection_fisheye": "Ojo de pez",
  "projection_pannini": "Panini",
  "projection_architectural": "Arquitectónica",
  "video_play": "Reproducir",
  "video_pause": "Pausa",
  "gallery_prev": "Anterior",
  "gallery_next": "Siguiente",
  "floor": "Planta {level}",
  "pdf_page": "Página {page} de {total}",
  "model_ar": "Ver en tu espacio (AR)",
  "error_load": "No se pudo cargar el contenido",
  "transcript": "Transcripción",
  "invalid_email": "Introduce un email válido",
  "vr_exit": "Salir de VR",
  "vr_rotate_device": "Gira el móvil en horizontal para usarlo con las gafas",
  "vr_open_outside": "Este contenido se abre fuera del modo inmersivo.",
  "vr_queue_open": "Abrir al salir de VR",
  "vr_exit_and_view": "Salir de VR y verlo",
  "vr_stay": "Seguir en VR",
  "vr_video_outside": "Los vídeos de {provider} no se pueden reproducir dentro de las gafas. Sal de la realidad virtual para verlo en el recorrido.",
  "vr_pdf_error": "No se pudo abrir el documento dentro de las gafas.",
  "video_sound_on": "Activar el sonido",
  "pdf_scroll_up": "Subir",
  "pdf_scroll_down": "Bajar",
  "pdf_read_text": "Leer como texto grande",
  "pdf_read_page": "Ver la página original",
  "compare_hint": "Apunta y mantén para mover el divisor",
  "vr_needs_https": "El modo VR necesita una conexión segura (HTTPS).",
  "vr_open_new_tab": "La realidad virtual no está permitida dentro de esta página: el recorrido se abre en una pestaña nueva.",
  "vr_hint_hands": "Apunta con la mano o el mando y pellizca para activar",
  "hotspot_navigation": "Navegación",
  "hotspot_text": "Texto",
  "hotspot_image": "Imagen",
  "hotspot_gallery": "Galería",
  "hotspot_videoFile": "Vídeo",
  "hotspot_embedVideo": "Vídeo embebido",
  "hotspot_audio": "Audio",
  "hotspot_pdf": "Documento PDF",
  "hotspot_model3d": "Modelo 3D",
  "hotspot_web": "Contenido web",
  "hotspot_form": "Formulario",
  "hotspot_compare": "Comparador",
  "hotspot_quiz": "Pregunta",
  "hotspot_polygon": "Zona",
  "hotspot_tooltip": "Etiqueta",
  "hotspot_link": "Enlace",
  "hotspot_state": "Acción",
  "vr_needs_motion": "Para mirar alrededor moviendo el móvil hace falta tu permiso para leer el movimiento y la orientación.",
  "vr_allow_motion": "Permitir el movimiento",
  "vr_motion_settings": "Si no aparece la pregunta, actívalo en Ajustes › Safari › Movimiento y orientación, y vuelve a entrar.",
  "treasure_found": "¡Lo encontraste!",
  "treasure_hint": "Pista",
  "kiosk_routes": "Recorridos",
  "kiosk_exploring": "Estás explorando por tu cuenta",
  "kiosk_resume": "Volver al recorrido",
  "kiosk_playing": "Reproduciendo «{name}»",
  "kiosk_touch_hint": "Toca la pantalla para explorar tú",
  "projection_rectilinear_desc": "La vista normal: como mirar con los ojos.",
  "projection_littlePlanet_desc": "Toda la esfera como un planeta pequeño visto desde arriba.",
  "projection_fisheye_desc": "Gran angular curvo: cabe mucho más en la pantalla.",
  "projection_pannini_desc": "Ancho sin deformar las rectas verticales. Ideal en interiores.",
  "projection_architectural_desc": "Mantiene las verticales rectas al mirar arriba o abajo.",
  "quiz_gate_scene": "Responde correctamente para poder avanzar",
  "kiosk_ended": "El recorrido ha terminado",
  "kiosk_replay": "Verlo otra vez",
  "kiosk_start": "Ver el recorrido",
  "web_open_external": "Abrir en una pestaña nueva",
  "web_blocked_hint": "Si aquí no aparece nada, esa web no permite incrustarse en otras páginas.",
  "autoplay_finished": "Visita terminada",
  "quiz_retry": "Volver a intentarlo",
  "quiz_name_for_result": "Tu nombre para el resultado",
  "quiz_send_result": "Enviar el resultado",
  "quiz_result_sent": "Resultado enviado",
  "quiz_result_error": "No se pudo enviar el resultado. Inténtalo de nuevo.",
  "form_gate_scene": "Envía el formulario de esta escena para poder avanzar",
  "form_already_sent": "Ya has enviado este formulario. Gracias.",
  "treasure_gate_scene": "Encuentra el tesoro de esta escena para poder avanzar",
  "nav_gate_scene": "Completa lo pendiente en esta escena para poder avanzar",
  "treasure_complete_all": "¡Has encontrado todos los tesoros!",
  "treasure_show_hint": "Ver una pista",
  "treasure_no_hint": "Aquí no hay pista: sigue buscando.",
  "treasure_none_here": "No quedan tesoros por encontrar en esta escena."
}
